import { Injectable } from "@angular/core";
import { PecaModel } from "../../app/models/OrcamentoModel";
import { HttpProvider } from "../http/http";


@Injectable()
export class OrcamentoProvider {
    
    constructor (private httpSrv: HttpProvider) 
    {
    }

    async getDmsPeca(cnpj: string, codigo: string, tipo: number, dms: number, urlintegracao: string, marca: string, veiculo: any, tipoOS: string, loading: number = 1, buscapecasubstituta: number = 0): Promise<Array<PecaModel>> {

        if(!urlintegracao)
        {
            urlintegracao = "https://dms.camptecnologia.com.br/";
        }

        let nomedms = "";
            
        if(dms == 1)
            nomedms = "dealernet";
        else if(dms == 2)
            nomedms = "apollo";
        else if(dms == 3)
            nomedms = "nbs";
        else if(dms == 4)
            nomedms = "sisdia";
        else if(dms == 5)
            nomedms = "sercon";
        else if(dms == 6)
            nomedms = "siare";
        else if(dms == 7)
            nomedms = "workflow";
        else if(dms == 8)
            nomedms = "camp";
        else if(dms == 9)
            nomedms = "gaia";
        else if(dms == 10)
            nomedms = "API-WorkFlow";
        else if(dms == 11)
            nomedms = "API-Apollo";
        else if(dms == 12)
            nomedms = "API-NBS";

        let form: any = {};
        form.dmsnome = nomedms;
        form.dms = dms;
        form.marca = marca;
        if(tipo == 1)
        {
            form.referencia = codigo;
        }
        else
        {
            form.descricao = codigo;
        }

        form.veiculo = veiculo;
        form.tipoOS = tipoOS;
        
        try {

            let ResultConn;

            if(buscapecasubstituta == 0)
            {
                if(dms == 10 || dms == 11 || dms == 12 || dms == 7)
                {
                    ResultConn = await this.httpSrv.postDmsCamp('buscarPecas/' + cnpj, JSON.stringify(form), loading,"Carregando os dados...",false, 1, 25000);
                }
                else
                {
                    ResultConn = await this.httpSrv.getDms(urlintegracao+'peca/' + cnpj + '/' + marca + '/' + codigo.replace("/", "|") + '/' + tipo + '/' + nomedms);
                }
            }
            else
            {
                ResultConn = await this.httpSrv.getDms(urlintegracao+'pecasubstituta/' + cnpj + '/' + marca + '/' + codigo.replace("/", "|") + '/' + tipo + '/' + nomedms,1,"Buscando Peça Substituta...");
            }

            

            console.log('ResultConn',ResultConn);
            if (ResultConn.success) {
            console.log('providers',ResultConn.data);
            // Converte cobrar para número 1/0
            if(ResultConn.data && Array.isArray(ResultConn.data)) {
                ResultConn.data.forEach(item => {
                    if(typeof item.cobrar === 'boolean') {
                        item.cobrar = item.cobrar ? 1 : 0;
                    } else if(item.cobrar === undefined || item.cobrar === null) {
                        item.cobrar = 1;
                    }
                });
            }
            return <Array<PecaModel>>ResultConn.data;
            }
        } catch (error) {
            console.log('problema ao carregar as busca placa dealernet online', error);
        }
    }

    async getDmsTMO(cnpj: string, codigo: string, tipo: number, dms: number, urlintegracao: string, marca: string, veiculo: any, tipoOS: string, loading: number = 1): Promise<Array<PecaModel>> {

        if(!urlintegracao)
        {
            urlintegracao = "https://dms.camptecnologia.com.br/";
        }

        let nomedms = "";
            
        if(dms == 1)
            nomedms = "dealernet";
        else if(dms == 2)
            nomedms = "apollo";
        else if(dms == 3)
            nomedms = "nbs";
        else if(dms == 4)
            nomedms = "sisdia";
        else if(dms == 5)
            nomedms = "sercon";
        else if(dms == 6)
            nomedms = "siare";
        else if(dms == 7)
            nomedms = "workflow";
        else if(dms == 8)
            nomedms = "camp";
        else if(dms == 9)
            nomedms = "gaia";
        else if(dms == 10)
            nomedms = "API-WorkFlow";
        else if(dms == 11)
            nomedms = "API-Apollo";
        else if(dms == 12)
            nomedms = "API-NBS";
        
        let form: any = {};
        form.dmsnome = nomedms;
        form.dms = dms;
        form.marca = marca;
        if(tipo == 1)
        {
            form.referencia = codigo;
        }
        else
        {
            form.descricao = codigo;
        }

        form.veiculo = veiculo;
        form.tipoOS = tipoOS;
        
        try {

            let ResultConn;

            if(dms == 10 || dms == 11 || dms == 12 || dms == 7)
            {
                ResultConn = await this.httpSrv.postDmsCamp('buscarServicos/' + cnpj, JSON.stringify(form), loading,"Carregando os dados...",false, 1, 25000);
            }
            else
            {
                ResultConn = await this.httpSrv.getDms(urlintegracao+'tmo/' + cnpj + '/' + marca + '/' + codigo + '/' + tipo + '/' + nomedms);
            }
            
            //console.log('ResultConn',ResultConn);
            if (ResultConn.success) {
            //console.log('providers',ResultConn.data);
            // Converte cobrar para número 1/0
            if(ResultConn.data && Array.isArray(ResultConn.data)) {
                ResultConn.data.forEach(item => {
                    if(typeof item.cobrar === 'boolean') {
                        item.cobrar = item.cobrar ? 1 : 0;
                    } else if(item.cobrar === undefined || item.cobrar === null) {
                        item.cobrar = 1;
                    }
                });
            }
            return <Array<PecaModel>>ResultConn.data;
            }
        } catch (error) {
            console.log('problema ao carregar as busca placa dealernet online', error);
        }
    }

    async getMontadoraPeca(chassi: string, data:string, q:string, loading: number = 1): Promise<any> {
        try {
          let ResultConn = await this.httpSrv.getChecklist('parceiros/recall/parts?chassi='+chassi+"&data="+data+"&q="+q,loading,"Buscando Peças...",null,31000);
          if (ResultConn.success) {
            const retorno = ResultConn.data && ResultConn.data.data?  ResultConn.data.data : "";
            return<Array<PecaModel>>retorno;
          }
        } catch (error) {
          console.log('problema ao consultar recall', error);
        }
      }

      async getMontadoraTMO(chassi: string, data:string, q:string, loading: number = 1): Promise<any> {
        try {
          let ResultConn = await this.httpSrv.getChecklist('parceiros/recall/labor?chassi='+chassi+"&data="+data+"&q="+q,loading,"Buscando Serviços...",null,31000);
          if (ResultConn.success) {
            const retorno = ResultConn.data && ResultConn.data.data?  ResultConn.data.data : "";
            return<Array<PecaModel>>retorno;
          }
        } catch (error) {
          console.log('problema ao consultar recall', error);
        }
      }



}


// WEBPACK FOOTER //
// ./src/providers/orcamento/orcamento.ts